import { FC, useState } from 'react'
import { downloadArquivo, IconPaths, showError } from '../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import {
  Button,
  DateInput,
  InfoAlert,
  LoadingIndicator,
  TableCard,
  TableFilter,
  TableFilters,
} from '../../../../components'
import { exportarAuditoriaCsv } from './core/_requests'

/** Exportação da trilha de auditoria (CSV) por período — não é listagem, só o período + exportar. */
export const AuditoriaExport: FC = () => {
  const { t } = useT()

  const [periodo, setPeriodo] = useState({ dataInicio: '', dataFim: '' })
  const [loading, setLoading] = useState(false)

  const hoje = new Date()
  const periodoCompleto = !!(periodo.dataInicio && periodo.dataFim)

  const exportar = async () => {
    if (!periodoCompleto) return
    setLoading(true)

    try {
      const arquivo = await exportarAuditoriaCsv(periodo.dataInicio, periodo.dataFim)
      await downloadArquivo(arquivo)
    } catch (error) {
      showError(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <TableCard>
      <div className='card-header border-0 pt-6'>
        <TableFilters
          actions={
            <Button
              className='btn-primary'
              icon={loading ? undefined : IconPaths.Download}
              onClick={exportar}
              disabled={!periodoCompleto || loading}
              title={periodoCompleto ? undefined : 'Informe o período para exportar'}
              ariaLabel={loading ? 'Exportando CSV…' : undefined}
            >
              {loading ? <LoadingIndicator /> : t('auditoria_export.export_csv')}
            </Button>
          }
        >
          <TableFilter label={t('auditoria_export.data_inicio')}>
            <DateInput
              value={periodo.dataInicio}
              maxDate={periodo.dataFim || hoje}
              onChange={(e) => setPeriodo((prev) => ({ ...prev, dataInicio: e.target.value }))}
              required
            />
          </TableFilter>
          <TableFilter label={t('auditoria_export.data_fim')}>
            <DateInput
              value={periodo.dataFim}
              minDate={periodo.dataInicio || undefined}
              maxDate={hoje}
              onChange={(e) => setPeriodo((prev) => ({ ...prev, dataFim: e.target.value }))}
              required
            />
          </TableFilter>
        </TableFilters>
      </div>
      <div className='card-body pt-0'>
        <InfoAlert variant='info' className='mb-0'>
          {t('auditoria_export.notice')}
        </InfoAlert>
      </div>
    </TableCard>
  )
}
